<script setup lang="ts">
import { BlockPreviewProps, type BlockPreviewEmits } from './block-preview.interface';
import { NxtIcon } from '@future-harry/nxt-styles';

const isHovered = ref(false);

defineEmits<BlockPreviewEmits>();
const props = defineProps(BlockPreviewProps);
</script>

<template>
   <div
      @click="$emit('onSelect', id)"
      :class="['content-block-container', { 'content-block-container--selected': isSelected }]"
      @mouseenter="isHovered = true"
      @mouseleave="isHovered = false"
   >
      <div v-if="isSelected || isHovered" class="content-block-container__action-bar">
         <span v-if="props.blockDefinition.isDraggable" class="content-block-container__action-bar-drag">
            <NxtIcon name="up-down-left-right" color="var(--nxt-light)" type="thin" />
         </span>
         <span :class="{ 'content-block-container__action-bar-name': !props.blockDefinition.isDraggable }">{{
            $t(props.blockDefinition.i18n.name)
         }}</span>
         <span v-if="props.blockDefinition.isRemovable" @click.stop="$emit('onRemove', id)">
            <NxtIcon name="trash" color="var(--nxt-light)" size="small" />
         </span>
      </div>
      <component :is="blockDefinition.components.content" :data="data" :preview="true" style="pointer-events: none" />
   </div>
</template>

<style lang="scss" scoped>
.content-block-container {
   position: relative;
   margin: 50px 5px;
   padding: 10px 0;
   border: 2px solid transparent;
   border-radius: 5px;
   cursor: pointer;

   &:first-child {
      margin-top: 0;
   }

   &--selected,
   &:hover {
      border: 2px solid var(--nxt-main);
   }

   &__action-bar {
      background-color: var(--nxt-main);
      color: #fff;
      z-index: 1;
      position: absolute;
      left: 0;
      top: 0;
      display: flex;
      gap: 1rem;
      padding: 2px;
      padding-right: 10px;

      &-name {
         padding-left: 10px;
      }
   }
}
</style>
